import * as React from "react";

import { Markdown } from "kanopi-components/Markdown";
import { Block } from "kanopi-components/Block";
import { StatefulPanel } from "kanopi-components/Accordion";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

type TMarkdownProps = {
  content?: string;
  title?: string;
  expandable?: boolean;
  expanded?: boolean;
  centered?: boolean;
  wide?: boolean;
};

const MarkdownRhetorical: React.FC<TMarkdownProps> = ({
  content,
  title,
  expandable,
  expanded = false,
  centered = false,
  wide = false,
}) => (
  <WidthContainer maxWidth={wide ? "70%" : "600px"}>
    {/*
      WidthContainer could probably be not flex-centering by default.
      Components needing centering could have a centering wrapper.
      Widening this to 100% to ensure left-alignment.
    */}
    <Block width={centered ? "auto" : "100%"}>
      {expandable ? (
        <StatefulPanel title={title} initialState={{ expanded }}>
          <Markdown>{content}</Markdown>
        </StatefulPanel>
      ) : (
        <Markdown>{content}</Markdown>
      )}
    </Block>
  </WidthContainer>
);

export { MarkdownRhetorical };
